import styled from 'styled-components';
import { LoadImage } from 'components';
import { px2rem } from 'src/util';
import { Title, Text } from 'components';
import ChevronLeft from 'assets/chevron-left.svg';
import ChevronRight from 'assets/chevron-right.svg';

export const Wrapper = styled.section`
  background-color: #f3f1e8;

  @media screen and (min-width: 998px) {
    padding: ${px2rem(175)} 0;
  }

  @media screen and (max-width: 997px) {
    overflow: hidden;
    padding: 120px 0;
  }
`;

export const Grid = styled.div`
  @media screen and (min-width: 998px) {
    align-items: center;
    width: 100%;
  }

  @media screen and (max-width: 997px) {
  }
`;

export const Content = styled.div`
  position: relative;

  @media screen and (min-width: 1441px) {
    grid-column: 2 / span 14;
  }

  @media screen and (max-width: 1440px) and (min-width: 998px) {
    grid-column: 1 / span 16;
  }

  @media screen and (min-width: 998px) {
    display: flex;
  }
`;

const imageWrapperHeight = 722;
const imageWrapperWidth = 940;

export const BackgroundImages = styled.div`
  position: relative;

  @media screen and (min-width: 998px) {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  @media screen and (max-width: 997px) {
    height: 543px;
    left: 50%;
    position: relative;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 707px;
  }
`;

export const BackgroundImage = styled(LoadImage)`
  position: absolute;
  transition: transform 0.5s;
`;

export const BlueBackgroundImage = styled(BackgroundImage)`
  height: ${(559 / imageWrapperHeight) * 100}%;
  left: 0;
  top: 0;
  width: ${(656 / imageWrapperWidth) * 100}%;
`;

export const WhiteBackgroundImage = styled(BackgroundImage)`
  height: ${(618 / imageWrapperHeight) * 100}%;
  left: ${(106 / imageWrapperWidth) * 100}%;
  top: ${(53 / imageWrapperHeight) * 100}%;
  width: ${(725 / imageWrapperWidth) * 100}%;
  z-index: 1;
`;

export const GreenBackgroundImage = styled(BackgroundImage)`
  height: ${(559 / imageWrapperHeight) * 100}%;
  left: ${(284 / imageWrapperWidth) * 100}%;
  top: ${(163 / imageWrapperHeight) * 100}%;
  width: ${(656 / imageWrapperWidth) * 100}%;
`;

export const LogoImage = styled(LoadImage)`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.5s;
  z-index: 2;

  @media screen and (min-width: 998px) {
    max-width: ${(220 / imageWrapperWidth) * 100}%;
  }

  @media screen and (max-width: 997px) {
    max-width: 147px;
  }
`;

export const BackgroundImageWrapper = styled.div`
  position: relative;

  &.transitioning {
    ${BlueBackgroundImage} {
      transform: translateX(${px2rem(73)});
    }

    ${GreenBackgroundImage} {
      transform: translateX(${px2rem(-77)});
    }

    ${LogoImage} {
      opacity: 0;
    }
  }

  @media screen and (min-width: 998px) {
    padding-bottom: ${(imageWrapperHeight / 1433) * 100}%;
    width: 100%;
  }

  @media screen and (max-width: 997px) {
    height: 352px;
    margin-bottom: 60px;
    overflow: hidden;
    width: 100%;
  }
`;

export const StyledTitle = styled(Title)`
  @media screen and (min-width: 998px) {
    align-self: flex-start;
    margin-bottom: ${px2rem(43)};
  }

  @media screen and (max-width: 997px) {
    align-self: flex-end;
    font-size: 32px;
    margin-bottom: 60px;
    text-align: right;
  }
`;

export const StyledText = styled(Text)`
  margin-left: auto;
  position: relative;
  transition: opacity 0.5s;

  &::before,
  &::after {
    color: #d4ccc1;
    display: block;
    font-family: 'Univia Pro', 'Arial', 'sans-serif';
    font-weight: 700;
    line-height: 115%;
    position: absolute;
  }

  &::before {
    content: '“';
    font-size: ${px2rem(120)};
  }

  &::after {
    content: '”';
    font-size: ${px2rem(90)};
  }

  @media screen and (min-width: 998px) {
    width: ${px2rem(540)};

    &::before {
      top: -${px2rem(27)};
      right: calc(100% + ${px2rem(14)});
    }

    &::after {
      top: calc(100% - ${px2rem(10)});
      right: ${px2rem(14)};
    }
  }

  @media screen and (max-width: 997px) {
    font-size: 18px;
    text-align: right;

    &::before {
      top: -60px;
      left: 20px;
    }

    &::after {
      top: 100%;
      right: 0;
    }
  }
`;

export const CustomerName = styled.h3`
  color: #21aa91;
  font-size: ${px2rem(24)};
  font-weight: 700;
  line-height: 150%;
  transition: opacity 0.5s;
  padding-right: ${px2rem(16)};
  text-align: right;

  @media screen and (min-width: 998px) {
    margin-top: ${px2rem(30)};
  }

  @media screen and (max-width: 997px) {
    margin-top: 70px;
  }
`;

export const CustomerPosition = styled.h4`
  color: #2e3740;
  font-size: ${px2rem(16)};
  font-weight: 700;
  line-height: 150%;
  padding-right: ${px2rem(16)};
  text-align: right;
  transition: opacity 0.5s;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  &.transitioning {
    ${StyledText}, ${CustomerName}, ${CustomerPosition} {
      opacity: 0;
    }
  }

  @media screen and (min-width: 998px) {
    align-items: flex-end;
    padding: ${(150 / 1433) * 100}% 0 ${px2rem(40)};
    width: ${px2rem(679)};
  }

  @media screen and (max-width: 997px) {
    padding: 0 20px;
  }
`;

export const Buttons = styled.div`
  align-items: center;
  display: flex;

  @media screen and (min-width: 998px) {
    margin-left: auto;
    margin-top: auto;
  }

  @media screen and (max-width: 997px) {
    margin: 40px auto 0;
  }
`;

const ArrowButton = styled.button`
  background: center/100% no-repeat;
  color: transparent;
  font-size: 0;
  height: ${px2rem(36)};
  overflow: hidden;
  width: ${px2rem(18)};
`;

export const PrevButton = styled(ArrowButton)`
  background-image: url(${ChevronLeft});
`;

export const NextButton = styled(ArrowButton)`
  background-image: url(${ChevronRight});
`;

export const ButtonsList = styled.ul`
  align-items: center;
  display: flex;
  margin: 0 ${px2rem(40)};
`;

export const ButtonsListItem = styled.li`
  align-items: center;
  display: flex;
  height: ${px2rem(16)};
  justify-content: center;
  width: ${px2rem(16)};

  &:not(:last-of-type) {
    margin-right: ${px2rem(40)};
  }
`;

export const TabButton = styled.button<any>`
  background-color: #989997;
  border-radius: 50%;
  color: transparent;
  font-size: 0;
  height: ${px2rem(9)};
  transition: background-color 0.3s, height 0.2s, width 0.2s;
  width: ${px2rem(9)};

  ${({ active }) =>
    active &&
    `
      background-color: #38A89C;
      height: 100%;
      width: 100%;
    `}
`;
